import React from "react";
import { Link } from "react-router-dom";
import Popup from "./Popup";
import Heading from "./Heading";
import Input from "./Input";
import "../sass/Login.scss";

const ForgotPassword = () => {
  return (
    <Popup>
      <Heading type="H2">Forgot Password?</Heading>
      <Input type="email" label="Email" />
      <div className="popupFooter">
        <span></span>
        <span>
          <Link className="btn btn-link" to="/login">
            Cancel
          </Link>
          <button className="btn btn-primary">Reset</button>
        </span>
      </div>
    </Popup>
  );
};

export default ForgotPassword;
